export default {"src":"/blog/_next/static/media/app-store.825aca47.svg","height":40,"width":120};